import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Standard from "./sections/Standard";
import Footer from "@/reusable_sections/Footer";
import Whychoosevaleroelitedetailing from "./sections/Whychoosevaleroelitedetailing";
export default function AboutPage() {
  return <div>
      <Header />
      <Standard />
      <Whychoosevaleroelitedetailing />
      <Footer />
    </div>;
}